import { create } from 'zustand';

interface AiOperationsState {
  /**
   * True when any AI streaming operation is active for the page editor.
   * Used to disable actions that would conflict with in-flight generations
   * (e.g. creating a new page while AI is still streaming).
   */
  isStreaming: boolean;
  setIsStreaming: (value: boolean) => void;
}

export const useAiOperationsStore = create<AiOperationsState>((set) => ({
  isStreaming: false,
  setIsStreaming: (value: boolean) => set({ isStreaming: value }),
}));
